import React from 'react';
import ReactDOM from 'react-dom';
import { EventType } from '@azure/msal-browser';
import './index.css';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { msalInstance, loginRequest } from './authConfig';

class RootComponent extends React.Component {
  componentDidMount() {
    // Initialize MSAL instance and set up event callbacks only
    msalInstance.initialize().then(() => {
      // Event for handle callback
      msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
      });
    });
  }

  render() {
    return (
      <div className="App">
        <App pca={msalInstance} />
      </div>
    );
  }
}

ReactDOM.render(<RootComponent />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
